"use client";

import { useEffect, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
type Stat = {
  value: number;
  suffix: string;
  label: string;
  descriptor: string;
};
const stats: Stat[] = [{
  value: 150,
  suffix: "+",
  label: "پروژه‌های تکمیل‌شده",
  descriptor: "طراحی فضاهای مدرن و لوکس"
}, {
  value: 8,
  suffix: "",
  label: "سال تجربه تخصصی",
  descriptor: "خلق اتمسفر در معماری داخلی"
}, {
  value: 95,
  suffix: "%",
  label: "رضایت مشتریان",
  descriptor: "همکاری‌های بلندمدت و پایدار"
}, {
  value: 20,
  suffix: "",
  label: "سبک‌های طراحی",
  descriptor: "تنوع در اجرای ایده‌های خلاقانه"
}];
function CountUp({
  end,
  suffix,
  isVisible
}: {
  end: number;
  suffix: string;
  isVisible: boolean;
}) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!isVisible) return;
    const duration = 1800;
    const startTime = performance.now();
    const easeOutCubic = (t: number) => 1 - Math.pow(1 - t, 3);
    let rafId: number;
    const tick = (now: number) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = easeOutCubic(progress);
      setCount(Math.floor(eased * end));
      if (progress < 1) {
        rafId = requestAnimationFrame(tick);
      } else {
        setCount(end);
      }
    };
    rafId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafId);
  }, [end, isVisible]);
  return <span>
      <span className="text-foreground">{count}</span>
      <span className="text-primary">{suffix}</span>
    </span>;
}
export default function Impact() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.2
  });
  return <section data-section-id="5210" id="اعداد-درخشان-arq" className="dark bg-background text-foreground py-32 md:py-44 lg:py-[180px] px-6 md:px-12 lg:px-20">
      <div ref={ref} className="max-w-7xl mx-auto">
        {}
        <div className={`text-xs md:text-sm uppercase tracking-[0.3em] text-primary font-default mb-8 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          آمار و ارقام ما
        </div>

        {}
        <h2 className={`font-default font-light text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-foreground max-w-[720px] mb-12 transition-all duration-1000 delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
        fontSize: "clamp(2rem, 5vw, 64px)"
      }}>
          یک دهه مهندسیِ اتمسفر و زیبایی.
        </h2>

        {}
        <div className="mb-16 md:mb-24">
          <div className={`w-px bg-primary origin-top transition-all duration-700 delay-500 ${isVisible ? "h-20 opacity-100" : "h-0 opacity-0"}`} style={{
          height: isVisible ? "80px" : "0"
        }} />
        </div>

        {}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-16 lg:gap-y-0 relative">
          {stats.map((stat, i) => <div data-index={i} key={i} className={`relative px-4 md:px-8 lg:px-10 transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`} style={{
          transitionDelay: `${600 + i * 100}ms`
        }}>
              {}
              {i > 0 && <div className="hidden lg:block absolute left-0 top-0 bottom-0 w-px bg-border" />}

              {}
              {i >= 2 && <div className="lg:hidden absolute -top-8 left-4 right-4 h-px bg-border" />}

              {}
              {i % 2 === 1 && <div className="lg:hidden absolute left-0 top-0 bottom-0 w-px bg-border" />}

              {}
              <div className="font-default font-light leading-none mb-6 tracking-tight" style={{
            fontSize: "clamp(3.5rem, 9vw, 120px)"
          }}>
                <CountUp end={stat.value} suffix={stat.suffix} isVisible={isVisible} />
              </div>

              {}
              <div className="h-px bg-primary mb-5 transition-all duration-700" style={{
            width: isVisible ? "40px" : "0px",
            transitionDelay: `${1400 + i * 100}ms`
          }} />

              {}
              <div className="text-xs md:text-sm uppercase tracking-[0.2em] text-muted-foreground font-default mb-3">
                {stat.label}
              </div>

              {}
              <div className="font-default italic text-sm text-muted-foreground">
                {stat.descriptor}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}